/**
 * 원본: .references/gc-mono/packages/common/constants/language_iso.js
 * ISO 639-1 언어 코드 → 영어 이름 매핑
 */

const LANGUAGES: Record<string, string> = {
  aa: 'Afar', ab: 'Abkhazian', af: 'Afrikaans', ak: 'Akan', sq: 'Albanian',
  am: 'Amharic', ar: 'Arabic', an: 'Aragonese', hy: 'Armenian', as: 'Assamese',
  av: 'Avaric', ae: 'Avestan', ay: 'Aymara', az: 'Azerbaijani', ba: 'Bashkir',
  bm: 'Bambara', eu: 'Basque', be: 'Belarusian', bn: 'Bengali', bh: 'Bihari languages',
  bi: 'Bislama', bo: 'Tibetan', bs: 'Bosnian', br: 'Breton', bg: 'Bulgarian',
  my: 'Burmese', ca: 'Catalan', cs: 'Czech', ch: 'Chamorro', ce: 'Chechen',
  zh: 'Chinese', cv: 'Chuvash', kw: 'Cornish', co: 'Corsican', cr: 'Cree',
  cy: 'Welsh', da: 'Danish', de: 'German', dv: 'Divehi', nl: 'Dutch',
  dz: 'Dzongkha', el: 'Greek', en: 'English', eo: 'Esperanto', et: 'Estonian',
  ee: 'Ewe', fo: 'Faroese', fa: 'Persian', fj: 'Fijian', fi: 'Finnish',
  fr: 'French', fy: 'Western Frisian', ff: 'Fulah', fil: 'Filipino', ka: 'Georgian',
  gd: 'Gaelic', ga: 'Irish', gl: 'Galician', gv: 'Manx', gn: 'Guarani',
  gu: 'Gujarati', ht: 'Haitian', ha: 'Hausa', he: 'Hebrew', hz: 'Herero',
  hi: 'Hindi', ho: 'Hiri Motu', hr: 'Croatian', hu: 'Hungarian', ig: 'Igbo',
  is: 'Icelandic', io: 'Ido', ii: 'Sichuan Yi', iu: 'Inuktitut', ie: 'Interlingue',
  ia: 'Interlingua', id: 'Indonesian', ik: 'Inupiaq', it: 'Italian', jv: 'Javanese',
  ja: 'Japanese', kl: 'Kalaallisut', kn: 'Kannada', ks: 'Kashmiri', kr: 'Kanuri',
  kk: 'Kazakh', km: 'Central Khmer', ki: 'Kikuyu', rw: 'Kinyarwanda', ky: 'Kirghiz',
  kv: 'Komi', kg: 'Kongo', ko: 'Korean', kj: 'Kuanyama', ku: 'Kurdish',
  lo: 'Lao', la: 'Latin', lv: 'Latvian', li: 'Limburgan', ln: 'Lingala',
  lt: 'Lithuanian', lb: 'Luxembourgish', lu: 'Luba-Katanga', lg: 'Ganda',
  mk: 'Macedonian', mh: 'Marshallese', ml: 'Malayalam', mi: 'Maori', mr: 'Marathi',
  ms: 'Malay', mg: 'Malagasy', mt: 'Maltese', mn: 'Mongolian', na: 'Nauru',
  nv: 'Navajo', nr: 'South Ndebele', nd: 'North Ndebele', ng: 'Ndonga',
  ne: 'Nepali', nn: 'Norwegian Nynorsk', nb: 'Norwegian Bokmål', no: 'Norwegian',
  ny: 'Chichewa', oc: 'Occitan', oj: 'Ojibwa', or: 'Oriya', om: 'Oromo',
  os: 'Ossetian', pa: 'Panjabi', pi: 'Pali', pl: 'Polish', pt: 'Portuguese',
  ps: 'Pushto', qu: 'Quechua', rm: 'Romansh', ro: 'Romanian', rn: 'Rundi',
  ru: 'Russian', sg: 'Sango', sa: 'Sanskrit', si: 'Sinhala', sk: 'Slovak',
  sl: 'Slovenian', se: 'Northern Sami', sm: 'Samoan', sn: 'Shona', sd: 'Sindhi',
  so: 'Somali', st: 'Sotho', es: 'Spanish', sc: 'Sardinian', sr: 'Serbian',
  ss: 'Swati', su: 'Sundanese', sw: 'Swahili', sv: 'Swedish', ty: 'Tahitian',
  ta: 'Tamil', tt: 'Tatar', te: 'Telugu', tg: 'Tajik', tl: 'Tagalog',
  th: 'Thai', ti: 'Tigrinya', to: 'Tonga', tn: 'Tswana', ts: 'Tsonga',
  tk: 'Turkmen', tr: 'Turkish', tw: 'Twi', ug: 'Uighur', uk: 'Ukrainian',
  ur: 'Urdu', uz: 'Uzbek', ve: 'Venda', vi: 'Vietnamese', vo: 'Volapük',
  wa: 'Walloon', wo: 'Wolof', xh: 'Xhosa', yi: 'Yiddish', yo: 'Yoruba',
  za: 'Zhuang', zu: 'Zulu',
};

export function getLanguageName(code: string): string {
  return LANGUAGES[code] || code;
}

export default LANGUAGES;
